import React, { useState } from "react";
import RadioButton from "../Elements/RadioButton";
import StromPrivat from "../Types/StromPrivat";
import ErdgasPrivat from "../Types/ErdgasPrivat";
import HeizstromPrivat from "../Types/HeizstromPrivat";
import InputTypeHidden from "../Elements/InputTypeHidden";


const Privat = (props) => {
    const [active,setActive] = useState(props.energy);
    const [disableButton, setDisableButton] = useState(true);
    const [threshold, setThreshold] = useState();
    const [currentValue, setCurrentValue] = useState('');

    const renderElement = () => {
        switch (active) {
            case 'Strom':
                return <StromPrivat value={currentValue} setValue={setCurrentValue} setThreshold={setThreshold} setDisableButton={setDisableButton} setErrorText={props.setErrorText} setShowError={props.setShowError}/>
            case 'Erdgas':
                return <ErdgasPrivat value={currentValue} setValue={setCurrentValue} setThreshold={setThreshold} setDisableButton={setDisableButton} setErrorText={props.setErrorText} setShowError={props.setShowError}/>
            case 'Heizstrom':
                return <HeizstromPrivat setDisableButton={setDisableButton} setErrorText={props.setErrorText} setShowError={props.setShowError}/>
        }
    }

    const validate = (e) => {
        if((threshold && (parseInt(currentValue) > parseInt(threshold)))) {
            props.setShowError(true);
            props.setErrorText('Für Ihre Eingaben bieten wir aktuell keine Online-Produkte an. Gern informieren Sie unsere Privat- und Geschäftskundenberater zu individuellen Energieprodukten. <br><br><a href="tel:+4923812741252"> Tel. 02381 274-1252</a> oder E-Mail: <a href="mailto:pundg-vertrieb@stadtwerke-hamm.de">pundg-vertrieb@stadtwerke-hamm.de</a>');
            e.preventDefault();
        }
        if(!(currentValue>0)) {
            props.setShowError(true);
            props.setErrorText('Für die Berechnung ist eine Angabe des Verbrauchs notwendig.');
            e.preventDefault();
        }
    }

    return <div className="tab-pane fade active in in" id="privat">
        <form action="https://onlineservice.stadtwerke-hamm.de/internetportal/fo/portal/productSearch">
            <fieldset>
                <legend>Preisrechner</legend>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="select-energy clearfix">
                            <RadioButton active={active} setActive={setActive} name='Strom'/>
                            <RadioButton active={active} setActive={setActive} name='Erdgas'/>
                            {/* <RadioButton active={active} setActive={setActive} name='Heizstrom'/>*/}
                        </div>
                        {
                            renderElement()
                        }
                    </div>
                </div>
                <div className="buttons">
                    {
                        disableButton ?
                            <input className="btn btn-default btn-white pull-right"
                                   type="submit"
                                   value="Jetzt berechnen"
                                   disabled /> :
                            <input className="btn btn-default btn-white pull-right"
                                   type="submit"
                                   onClick={(e) =>validate(e)}
                                   value="Jetzt berechnen"/>
                    }
                </div>
            </fieldset>
        </form>
    </div>
}

export default Privat;